export enum ShootBlockingOperation {
  QUARANTINE = "quarantine",
  BLOCKLIST_AUTOMATIC = "blocklist-automatic",
  BLOCKLIST_MANUAL = "blocklist-manual",
  ENGAGEMENT = "engagement",
  RESPONSE = "response",
  REACTIVATION_AUTOMATIC = "reactivation-automatic",
  REACTIVATION_MANUAL = "reactivation-manual",
}
